<div *iCms="'copy' of content; content: 'html'; skipEmpty: true"></div>